import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import {
  defaultPageSearch,
  optionalCalendarDay,
  optionalPage,
  optionalSearch,
  poolContextSearchSchema,
} from "./shared";

const financingRoundSortSchema = z.enum(["createdAt:asc", "createdAt:desc"]);

export const poolActivitySearchDefaults = {
  ...defaultPageSearch,
  sort: "createdAt:desc" as const,
};

export const poolActivitySearchSchema = poolContextSearchSchema.extend({
  poolAddress: optionalSearch(z.string()),
  financingLimit: optionalSearch(z.coerce.number()),
  createdAfter: optionalCalendarDay,
  createdBefore: optionalCalendarDay,
  sort: optionalSearch(financingRoundSortSchema),
  page: optionalPage,
});

export type PoolActivitySearch = z.infer<typeof poolActivitySearchSchema>;

export const poolActivitySearchMiddlewares: SearchMiddleware<PoolActivitySearch>[] = [
  stripSearchParams(poolActivitySearchDefaults) as SearchMiddleware<PoolActivitySearch>,
];
